// extracted by mini-css-extract-plugin
module.exports = {"tab":"_772e1b1e50--tab--hL4ic","active":"_772e1b1e50--active--GX9HI","focus-visible":"_772e1b1e50--focus-visible--lbTPg","text":"_772e1b1e50--text--MalDc"};